import { useState, useEffect, useCallback } from 'react'
import { getProfile, updateProfile, deleteAccount } from '../api/library'

export function useLibraryProfile() {
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [saving, setSaving] = useState(false)
  const [deleting, setDeleting] = useState(false)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(null)

    getProfile()
      .then((data) => {
        if (!cancelled) setProfile(data)
      })
      .catch((err) => {
        if (!cancelled) setError(err.message)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [])

  const saveProfile = useCallback(async (updates) => {
    setSaving(true)
    try {
      const updated = await updateProfile(updates)
      setProfile(updated)
      return updated
    } finally {
      setSaving(false)
    }
  }, [])

  const removeAccount = useCallback(async () => {
    setDeleting(true)
    try {
      return await deleteAccount()
    } finally {
      setDeleting(false)
    }
  }, [])

  return {
    profile,
    loading,
    error,
    saving,
    deleting,
    saveProfile,
    removeAccount,
  }
}
